import { Grid, MenuItem, Button, Box, Chip } from "@mui/material";
import AlertDialog from "../../components/AlertDialog";

import PriceModal from "../../components/Events/PriceModal";
import FormikDateTimePicker from "../../components/Form/FormikDateTimePicker";
import FormikInput from "../../components/Form/FormikInput";
import FormikSelect from "../../components/Form/FormikSelect";
import Form from "../../components/Templates/Form";
import useEventContainer from "../../containers/Events/useEventContainer";
import { eventCategories } from "../../utils/constants";
import FormikMap from "../../components/Map";
import Info from "../../components/Info";
import ImageList from "../../components/ImageList";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { eventCategoriesAr } from "../../utils/translations";
import { translator } from "../../utils/translations/translator";

const AddEvent = () => {
  const {
    pageLoading,
    eventFormik,
    loading,
    center,
    handleMarker,
    handleSearch,
    setCenter,
    zoom,
    setZoom,

    prices,
    priceFormik,
    setOpenPriceDialog,
    openPriceDialog,

    handleOpenDeletePrice,
    setOpenDeletePriceDialog,
    openDeletePriceDialog,
    handleDeletePrice,

    selected,

    openDeleteDialog,
    setOpenDeleteDialog,
    handleDeleteImage,
    handleFile,
    handleOpenDeleteImage,
    images,
  } = useEventContainer();

  const { general, pages } = useContent();
  const { events } = pages;
  const { isRTL } = useRTL();

  return (
    <Form
      title={events.event}
      pageLoading={pageLoading}
      formik={eventFormik}
      submitLoading={loading}
      width="75%"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormikInput
            formik={eventFormik}
            name="title"
            label={events.titleEn}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikInput
            formik={eventFormik}
            name="details"
            label={events.detailsEn}
            multiline
            rows={3}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikInput
            formik={eventFormik}
            name="titleAr"
            label={events.titleAr}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikInput
            formik={eventFormik}
            name="detailsAr"
            label={events.detailsAr}
            multiline
            rows={3}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikSelect
            formik={eventFormik}
            name="category"
            label={events.category}
          >
            {eventCategories.map((category: any) => (
              <MenuItem key={category.value} value={category.value}>
                {isRTL
                  ? translator(category.label, eventCategoriesAr)
                  : category.label}
              </MenuItem>
            ))}
          </FormikSelect>
        </Grid>
        <Grid item xs={12}>
          <FormikInput
            formik={eventFormik}
            name="partnerCode"
            label={events.partnerCode}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormikDateTimePicker
            formik={eventFormik}
            name="publishDate"
            label={events.publishDate}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <FormikDateTimePicker
            formik={eventFormik}
            name="startDate"
            label={events.startDate}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <FormikDateTimePicker
            formik={eventFormik}
            name="endDate"
            label={events.endDate}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikMap
            center={center}
            setCenter={setCenter}
            markers={[
              {
                pos: {
                  lat: eventFormik.values.latitude,
                  lng: eventFormik.values.longitude,
                },
              },
            ]}
            handleMarker={(e: any) => handleMarker(e)}
            handleSearch={handleSearch}
            zoom={zoom}
            setZoom={setZoom}
            sx={{ height: "400px" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormikInput
            formik={eventFormik}
            type="number"
            name="latitude"
            label={events.lat}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormikInput
            formik={eventFormik}
            type="number"
            name="longitude"
            label={events.lng}
          />
        </Grid>
        <Grid item xs={12}>
          <Info title={events.images} />
          <ImageList images={images} handleAction={handleOpenDeleteImage} />

          <Button variant="contained" component="label" sx={{ my: 1 }}>
            {events.chooseFile}
            <input
              hidden
              accept="image/*"
              multiple
              type="file"
              key={images}
              onChange={handleFile}
            />
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Info title={events.prices} />
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {prices.map((price: any) => (
              <Chip
                key={price.title}
                sx={{ mr: 1, mb: 1 }}
                label={`${isRTL ? price.title.ar : price.title.en}: ${
                  price.price
                }`}
                color="primary"
                onDelete={() => handleOpenDeletePrice(price)}
              />
            ))}
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenPriceDialog(true)}
          >
            {general.add}
          </Button>
        </Grid>
      </Grid>

      <PriceModal
        formik={priceFormik}
        setOpen={setOpenPriceDialog}
        open={openPriceDialog}
        itemName={events.price}
      />

      <AlertDialog
        open={openDeletePriceDialog}
        handleClose={() => setOpenDeletePriceDialog(false)}
        onAgree={handleDeletePrice}
        loading={loading}
        agreeText={general.delete}
        disagreeText={general.cancel}
        title={`${general.sureDelete} (${
          isRTL ? selected?.title?.ar : selected?.title?.en
        })`}
      />

      <AlertDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        onAgree={handleDeleteImage}
        loading={loading}
        agreeText={general.delete}
        disagreeText={general.cancel}
        title={events.sureDeleteImg}
      />
    </Form>
  );
};

export default AddEvent;
